import styled from "react-emotion";
import { Draggable } from "react-beautiful-dnd";

const Container = styled("div")`
  border: ${(props) =>
    props.isDragging
      ? "1.5px solid white"
      : "1px solid rgba(224, 224, 224, 1)"};
  border-radius: 5px;
  padding: 12px;
  margin-bottom: 8px;
  color: ${(props) => (props.isDragging ? "white" : "black")};
  background-color: ${(props) => (props.isDragging ? "#89D2D3" : "white")};
  text-align: center;
  font-weight: ${(props) => (props.isDragging ? "bold" : "normal")};
  /* display: flex;
  justify-content: space-between;
  align-items: center; */
`;

function RowItem({ index, rowItem, isGallery }) {
  return (
    <Draggable index={index} draggableId={rowItem.id}>
      {(provided, snapshot) => {
        return (
          <Container
            innerRef={provided.innerRef}
            isDragging={snapshot.isDragging}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            {!isGallery && rowItem.content}
            {isGallery && (
              <img
                src={rowItem.url}
                style={{ width: "75px", height: "75px" }}
              />
            )}
          </Container>
        );
      }}
    </Draggable>
  );
}

export default RowItem;
